
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.39 5.858A9.5 9.5 0 0110.174 0a9.49 9.49 0 019.49 9.5A9.5 9.5 0 111.39 5.858zm16.233 6.53A8.066 8.066 0 0018.14 9.5a7.966 7.966 0 00-1.692-5.009c-.449.747-1.295 1.862-2.34 1.862a3.356 3.356 0 00-1.195.12v.11c0 .178.487.666.746.925A3.057 3.057 0 0114.854 9.5c0 1.593.16 2.081.3 2.2.86.062 1.7.296 2.469.688zM2.208 9.5A7.966 7.966 0 013.86 4.6c.282.515.827.83 1.414.817A6.493 6.493 0 017.366 7.09c-.422.26-.804.578-1.135.946a25.6 25.6 0 00-.1.097c-.275.267-.669.651-.836.66a1.673 1.673 0 00-1.723 1.723.757.757 0 00.08.328l.896 1.793c.011 1.03.176 2.054.488 3.037A7.966 7.966 0 012.208 9.5zm5.248 7.488a7.966 7.966 0 002.718.478v.03a7.966 7.966 0 006.771-3.684 6.603 6.603 0 00-1.901-.588c-1.723 0-1.723-2.47-1.723-3.664 0-.18-.444-.624-.718-.898l-.039-.038a3.067 3.067 0 01-1.185-1.992c0-1.723 1.753-1.723 2.689-1.723.259-.01.876-.747 1.254-1.483a7.966 7.966 0 00-10.246-.04.747.747 0 010 .259c.01.239.12.239.229.239 1.195 0 3.873 2.43 3.913 3.565a.896.896 0 01-.996.896c-.179.01-.667.498-.926.757a3.107 3.107 0 01-1.991 1.194c-.08 0-.2 0-.2.1l.867 1.663a.757.757 0 01.08.329c0 1.085.239 2.848.756 3.375.362.313.593.75.648 1.225z","fill":"#7B01B5"}})])
          )
        }
      }
    